// eslint-disable-next-line @typescript-eslint/no-var-requires
const twColors = require('tailwindcss/colors');
import themeColors from './themeColors.json';
const colors = {
  ...twColors,
  ...themeColors,
};
export type IColors = 'primary' | 'expenses' | 'revenues' | 'bank' | 'taxes';
export default colors;
